import React, { Component } from "react";
import moment from "moment";
import Button from "react-bootstrap/Button";
// import moment from "moment";
// import events from "./events";
// import UserService from "../services/user.service";
import UserService from "../services/user.service";

import DatePicker from "react-datepicker";
import type { AppointmentItem } from "./models";

type NewAppointmentEvent = {
  start: Date;
  end: Date;
};

const getErrorMessage = (error: unknown): string => {
  if (typeof error === "object" && error !== null) {
    const message = (error as { message?: string }).message;
    if (message) {
      return message;
    }
  }

  return "Unexpected error";
};

const postAppointments = async (appointments: NewAppointmentEvent[]) => {
  for (const appointment of appointments) {
    const appointmentData = {
      start_date_time: appointment.start,
      end_date_time: appointment.end,
    };
    try {
      await UserService.postAppointment(appointmentData);
    } catch (error) {
      console.log(getErrorMessage(error));
      throw error;
    }
  }
};

type AddAppointmentsState = {
  content: string;
  appointmentsData: AppointmentItem[];
  showAppointment: boolean;
  currentAppointment: AppointmentItem | null;
  startDate: Date;
  endDate: Date;
};

export default class Home extends Component<Record<string, never>, AddAppointmentsState> {
  // const Home = () =>  {
  constructor(props: Record<string, never>) {
    super(props);
    // const events = generateEvents();

    this.state = {
      content: "",
      appointmentsData: [],
      showAppointment: false,
      currentAppointment: null,
      startDate: new Date(),
      endDate: new Date(),
    };
  }

  showModal = (props: AppointmentItem) => {
    this.setState({ showAppointment: true, currentAppointment: props });
  };

  hideModal = () => {
    this.setState({ showAppointment: false });
  };

  handleSelect = (props: AppointmentItem) => {
    this.setState({ showAppointment: true, currentAppointment: props });
  };

  appointmentChanged = () => {
    this.getAppointments();
  };

  componentDidMount() {
    // this.getAppointments();
    // UserService.getPublicContent().then(
    //   response => {
    //     this.setState({
    //       content: response.data
    //     });
    //   },
    //   error => {
    //     this.setState({
    //       content:
    //         (error.response && error.response.data) ||
    //         error.message ||
    //         error.toString()
    //     });
    //   }
    // );
  }

  getAppointments = async () => {
    try {
      const result = await UserService.getAppointments();
      this.setState({ appointmentsData: result.data.data });
      return result.data.data;
    } catch (error) {
      console.log(getErrorMessage(error));
      throw error;
    }
  };

  formatEndDate = (props: { endDateTime: string }) => {
    return new Date(props.endDateTime);
  };

  formatStartDate = (props: { startDateTime: string }) => {
    return new Date(props.startDateTime);
  };

  formatTitle = (appointment: {
    startDateTime: string;
    status: string;
    client?: { clientName: string };
  }) => {
    const hour = moment(appointment.startDateTime).format("h a");
    if (appointment.status === "draft") {
      return `${hour}: available`;
    } else {
      // return "xxx";
      return `${hour}: ${appointment.client?.clientName || "appointment"}`;
    }
  };

  setStartDate = (date: Date | null) => {
    if (!date) {
      return;
    }

    this.setState({ startDate: date });
  };

  setEndDate = (date: Date) => {
    this.setState({ endDate: date });
  };

  onEndDateChange = (date: Date | null) => {
    if (date) {
      this.setEndDate(date);
    }
  };

  generateEvents = () => {
    const eventsData: NewAppointmentEvent[] = [];
    const cursorDate = new Date(this.state.startDate);
    const endDate = new Date(this.state.endDate);
    for (
      let ourDate = cursorDate;
      ourDate <= endDate;
      ourDate = new Date(ourDate.setDate(ourDate.getDate() + 1))
    ) {
      // remove Sundays
      if (ourDate.getDay() === 0) {
        continue;
      }
      const appointmentStartDate = new Date(ourDate.setHours(9, 0, 0));
      const appointmentEndDate = new Date(ourDate.setHours(12, 0, 0));
      const appointment2StartDate = new Date(ourDate.setHours(13, 0, 0));
      const appointment2EndDate = new Date(ourDate.setHours(16, 0, 0));
      eventsData.push(
        {
          start: appointmentStartDate,
          end: appointmentEndDate,
        },
        {
          start: appointment2StartDate,
          end: appointment2EndDate,
        }
      );
    }
    postAppointments(eventsData);
    return eventsData;
  };

  render() {
    return (
      <>
        <div className="container">
          <header className="jumbotron">
            <h3>{this.state.content}</h3>
          </header>
        </div>
        <div>
          Start date:
          <DatePicker
            selected={this.state.startDate}
            onChange={this.setStartDate}
          />
        </div>
        <div>
          End date:
          <DatePicker
            selected={this.state.endDate}
            onChange={this.onEndDateChange}
          />
        </div>
        <div>
          <Button variant="primary" onClick={this.generateEvents}>
            Add new appointments
          </Button>
        </div>
      </>
    );
  }
}
